import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { configHomePage_template } from "../components/templates/configHomePage_template";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import * as classicEditor from "@ckeditor/ckeditor5-build-classic";

declare var ko: any;
declare var page: any;

export class config_home_page extends vnModule_knockoutJS {


    protected imageXHRHdl: XMLHttpRequestHandler;
    protected XHRHdl: XMLHttpRequestHandler;
    protected configHomePage: configHomePage_template;
    protected validationsList: validationsList_template;

    protected loadingPinnedArticlesHome: boolean = false;
    protected loadingWordpressCategories: boolean = false;
    protected loadingPinnedCategoriesHome: boolean = false;
    protected listingPageIdElement: string = 'filterListingPageTemplate';
    protected _isLeavePageWarningNeeded: boolean = true;
    protected textAreaEditor;
    protected CKEDITOR_CONFIG = {
        toolbar: ["bold", "|", "italic", "link"],
    };


    protected getModuleName() {
        return "config_home_page";
    }

    public getBrandId() {
        return Number(this.getVnAppZone().app.params.idBrand);
    }

    buildContent(): Array<Element> {

        this.configHomePage = new configHomePage_template("configHomePage", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Config Home Page");

        return [this.configHomePage.build()];
    }

    public fillPage(): void {

        this.getReferences();
    }

    public getReferences(): void {
        
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.configHomePage.activateLoading();

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/listing-pages/references/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetReferencesReturn;
        this.XHRHdl.execute();
    }

    protected onGetReferencesReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.configHomePage.getTemplateViewModel().tagTrendingLogicConfig(responseParsed.tagTrendingLogicConfig);
                // obj.configHomePage.getTemplateViewModel().isDbPageRatingEnabled(responseParsed.tagTrendingLogicConfig && responseParsed.tagTrendingLogicConfig.rating_enabled ? responseParsed.tagTrendingLogicConfig.rating_enabled : false);
                
                obj.getPinnedArticlesHome(); 
            });
        }
    }

    protected getPinnedArticlesHome() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.loadingPinnedArticlesHome = true;

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/pinnedArticleHome/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPinnedArticlesHomeReturn;
        this.XHRHdl.execute();
    }

    protected onGetPinnedArticlesHomeReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                
                obj.configHomePage.setPermissions(responseParsed.data.permissions);
                obj.configHomePage.setPinnedArticles(responseParsed.data.articles);
                obj.configHomePage.setLayoutOptions(responseParsed.data.homePageLayoutOptions);
                obj.configHomePage.setLayoutSelected(responseParsed.data.homePageLayoutSelected);
                obj.configHomePage.setHeaderLatestSelected(responseParsed.data.selectedHeaderLatestOptions);
                obj.configHomePage.setPinnedWidgets(responseParsed.data.pinnedWidgets);
                obj.configHomePage.setRatingWidgetEnabled(responseParsed.data.ratingWidgetEnabled);
                
                let brand = obj.getVnAppZone().getApp().params.idBrand;
                obj.configHomePage.setIsMLT(Number(brand) === 50);
                if (Number(brand) === 50) {
                    obj.configHomePage.setHomePageEventBanner(responseParsed.data.homePageEventBanner);
                }
                if(brand == 48 || brand == 43){ //HG and FX
                    obj.configHomePage.getTemplateViewModel().lightBackgroundDisabled(true);   
                }
                if(brand == 48){
                    obj.configHomePage.setIsFX(true);
                }
                // set enable layout featured pinned title
                if(responseParsed.data.homePageLayoutSelected && responseParsed.data.homePageLayoutSelected.id == 3 && responseParsed.data.selectedHeaderLatestOptions && responseParsed.data.selectedHeaderLatestOptions.availableArticleCount == 9){
                    obj.configHomePage.getTemplateViewModel().enableLayoutFeaturedPinnedTitle(true);
                }
                //only for CBR brand
                if(brand == 5){
                    obj.configHomePage.getTemplateViewModel().isTradingCardFeatureEnabled(true);
                }
                obj.getPinnedListingPages();

                obj.loadingPinnedArticlesHome = false;
            })
        }
    }

    public getPinnedListingPages(): void {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/config/listing-pages/home/pinned/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPinnedListingPagesReturn;
        this.XHRHdl.execute();
    }

    protected onGetPinnedListingPagesReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response) {

                    obj.configHomePage.setPinnedListingPages(response);
                    obj.getHomepageSidebarLinks();
                }

            });
        }
    }

    protected getHomepageSidebarLinks() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/sidebarFeaturedLinks/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPinnedArticlesSidebarLinksReturn;
        this.XHRHdl.execute();
    }

    protected onGetPinnedArticlesSidebarLinksReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                if(responseParsed.data.homepage_sidebar_links != null){
                    obj.configHomePage.setSidebarFeaturedLinks(responseParsed.data.homepage_sidebar_links.pinnedSidebarSections);
                    obj.configHomePage.setSidebarSectionTabTitle(responseParsed.data.homepage_sidebar_links.tabTitle);
                }

                obj.getDbHomeSpotlight();
            })
        }
    }

    protected getDbHomeSpotlight() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.loadingPinnedArticlesHome = true;

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/listing-pages/db-home/pinned/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.getDbHomeSpotlightReturn;
        this.XHRHdl.execute();
    }

    protected getDbHomeSpotlightReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.configHomePage.setPinnedDbSpotlight(responseParsed);
                obj.loadingPinnedArticlesHome = false;
                obj.getPinnedCustomCardsSection();
                obj.initCkEditor();
            })
        }
    }

    protected getPinnedTradingCards() {
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.loadingPinnedArticlesHome = true;

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/listing-pages/trading-card/pinned/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.getPinnedTradingCardsReturn;
        this.XHRHdl.execute();
    }

    protected getPinnedTradingCardsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.configHomePage.setPinnedTradingCards(responseParsed);
                obj.loadingPinnedArticlesHome = false;
                obj.configHomePage.deactivateLoading(); 
            })
        }
    }

    public cancelForm() {
        this.cancelHomePageConfig();
        page.redirect(this.getVnAppZone().app.getLastRoute());
    }

    protected cancelHomePageConfig() {

        this.getPinnedArticlesHome();
        this.triggerNotification("Pinned Articles Cancelled!");
    }

    public triggerNotification(message: string): void {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, message);
        this.getVnAppZone().showNotificationToModule();
    }

    protected saveHomePageConfig() {


        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.configHomePage.activateLoading();

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/pinnedArticleAndListingPageHome/save/";

        let formReq_params: Array<Array<string>> = [];


        formReq_params.push(["data", ko.toJSON(this.configHomePage.getViewModelForRequest())]);

        this.XHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    obj.getPinnedArticlesHome();
                    //let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Home Page Config saved successfully !");
                    obj.getVnAppZone().showNotificationToModule();
                });

                obj.configHomePage.deactivateLoading();
            }
        });
        this.XHRHdl.execute();


    }

    protected saveHomeSidebarFeaturedLinks() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.configHomePage.activateLoading();

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/sidebarFeaturedLinks/save/";

        let formReq_params: Array<Array<string>> = [];


        formReq_params.push(["data", ko.toJSON(this.configHomePage.getViewModelForRequest())]);

        this.XHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    obj.getPinnedArticlesHome();
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Home Page Config saved successfully !");
                    obj.getVnAppZone().showNotificationToModule();

                })
            }
        });
        this.XHRHdl.execute();
    }

    protected getArticlesSuggestion(keyword, idElement) {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response || "{}");

                if (req.request.status == 200) {
                    if (responseParsed.data.articles) {
                        let x = responseParsed.data.idElement;

                        obj.configHomePage.setArticleFilterAutocomplete(responseParsed.data.idElement, responseParsed.data.articles);
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                } else {
                    obj.configHomePage.onUpdateError(req.request.status, responseParsed);
                }

            }
        }
    }

    protected filterSimpleOnChange(idElement) {

        console.log(idElement);
        switch (idElement) {
            case 'filterListingPageTemplate':
            case 'filterSowMoreListingPageTemplate':
            case 'filterSidebarLinksListingPage':
                break;
            case 'filterHubPageLeft':
                let listingPageObj = this.configHomePage.listingPageFilterLeft.getTemplateViewModel().listingPageObj();
                this.configHomePage.setFilterHubPageLeft(listingPageObj);
                break;
            case 'filterHubPageRight':
                let listingPageObjRight = this.configHomePage.listingPageFilterRight.getTemplateViewModel().listingPageObj();
                this.configHomePage.setFilterHubPageRight(listingPageObjRight);
                break;
            case 'filterHubPageFullWidth':
                let listingPageObjFullWidth = this.configHomePage.listingPageFilterFullWidth.getTemplateViewModel().listingPageObj();
                this.configHomePage.setFullWidthWidgetHubPage(listingPageObjFullWidth);
            case 'filterHubPageLeftShowMore':
                let listingPageObjShowMore = this.configHomePage.listingPageFilterLeftShowMore.getTemplateViewModel().listingPageObj();
                this.configHomePage.setFilterHubPageLeftShowMore(listingPageObjShowMore);
                break;
            case 'filterHubPageRightShowMore':
                let listingPageObjRightShowMore = this.configHomePage.listingPageFilterRightShowMore.getTemplateViewModel().listingPageObj();
                this.configHomePage.setFilterHubPageRightShowMore(listingPageObjRightShowMore);
                break;
            case 'filterHubPageFullWidthShowMore':
                let listingPageObjFullWidthShowMore = this.configHomePage.listingPageFilterFullWidthShowMore.getTemplateViewModel().listingPageObj();
                this.configHomePage.setFullWidthWidgetHubPageShowMore(listingPageObjFullWidthShowMore);
            default:
                break;
        }

    }

    protected onAutocompleteInputClear(idElement){

    }

    protected getListingPagesSuggestion(keyword, idElement): void {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let filterData = { keyword: keyword };
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/config/listing-pages/search/";

        if(this.configHomePage.getTemplateViewModel().isDbPageTabActive()){

            usrReq_url= '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/config/listing-pages/db-pages/search/";
            let config =  this.configHomePage.getTemplateViewModel().tagTrendingLogicConfig();
            if (config && config.id_tag_types) {
                filterData['idTagTypes'] = config.id_tag_types;
            }
        }

        let subViewModel = {pagination: {itemPerPage: 25}, filter: filterData, idElement: idElement};
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetListingPagesSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetListingPagesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.listingPages) {

                    obj.configHomePage.setFilterListingPagesAutoComplete(response.data.listingPages, response.data.idElement);
                }
            });
        }
    }
    
    protected getDbPagesSuggestion(keyword, idElement): void {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let filter = {};
        filter['keyword'] = keyword;
        let config =  this.configHomePage.getTemplateViewModel().tagTrendingLogicConfig();
        if (config && config.id_tag_types) {
            filter['idTagTypes'] = config.id_tag_types;
        }

        let subViewModel = {pagination: {itemPerPage:25}, filter: filter,  idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/tag/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdl.execute();
    }


    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.tags) {

                    obj.configHomePage.dbPageTagFilter.setTags(responseParsed.data.tags);
                }

            });
        }
    }

    protected filterDropdownOnChange(idElement) {
        this.getImageData();
    }

    protected onAutocompleteInputClick() {

    }

    protected onAutocompleteAddNewInputClick(idElement) {

    }

    protected getSuggestions(keyword, idElement) {

        if(idElement == 'filterSidebarLinksArticle') {
            this.getArticlesSuggestions(keyword, idElement);
        }
    }

    protected getArticlesSuggestions(keyword, idElement) {

        if(this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesAutocompleteSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesAutocompleteSuggestionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.articles) {

                    let options = [];
                    responseParsed.data.articles.forEach(function(article){
                        options.push({id: article.id, name: article.title, reference: article.reference})
                    })
                    obj.configHomePage.setFiltersArticleAutocompleteOptions(options);
                }
            });
        }
    }

    protected onAutocompleteOptionChange(idElement) {

        if ( idElement == "filterSidebarLinksArticle" ){

        }
    }

    protected saveSidebarFeaturedLinksConfig() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.configHomePage.activateLoading();

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/sidebarFeaturedLinks/save/";

        let formReq_params: Array<Array<string>> = [];

        let sidebarSections = this.configHomePage.getTemplateViewModel().sidebarSections().map(x => x.value);

        for(let section of sidebarSections){
            section.links = section.links().map(x => x.value);
        }

        formReq_params.push(["data", ko.toJSON({sidebarSections: sidebarSections, tabTitle: this.configHomePage.getTemplateViewModel().sidebarSectionTabTitle()})]);

        this.XHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    obj.getPinnedArticlesHome();
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Sidebar Featured Links Config saved successfully !");
                    obj.getVnAppZone().showNotificationToModule();

                })

                obj.configHomePage.deactivateLoading();

            }
        });
        this.XHRHdl.execute();
    }

    protected initCkEditor() {

        if (this.textAreaEditor) {
            return;
        }

        const textArea = document.getElementById("customCardDescription");
        if (!textArea) {
          return;
        }
    
        this.makeEditor(textArea).then((newEditor) => {
            this.textAreaEditor = newEditor;
        });
    }

    protected makeEditor(textArea: HTMLElement): Promise<any> {
        return classicEditor
            .create(textArea, this.CKEDITOR_CONFIG)
            .catch((error) => {
            console.error(error);
            });
    }

    protected getPinnedCustomCardsSection() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.loadingPinnedArticlesHome = true;

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/homepage/pinnedCustomCards/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.getPinnedCustomCardsSectionReturn;
        this.XHRHdl.execute();
    }

    protected getPinnedCustomCardsSectionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.configHomePage.setPinnedCustomCardsSection(responseParsed.data);
                obj.loadingPinnedArticlesHome = false;
                obj.getFeaturedWikisSection();
            });
        }
    }

    protected getFeaturedWikisSection() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.loadingPinnedArticlesHome = true;

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/homepage/featuredWikis/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.getFeaturedWikisSectionReturn;
        this.XHRHdl.execute();
    }

    protected getFeaturedWikisSectionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.configHomePage.setFeaturedWikisSection(responseParsed.data);
                obj.loadingPinnedArticlesHome = false;
                if (obj.getBrandId() == 48) {
                    obj.getMultiListingPinnedSection();
                } else {
                    obj.getPinnedTradingCards();
                }
            });
        }
    }

    protected getMultiListingPinnedSection() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.loadingPinnedArticlesHome = true;

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/homepage/multiListingPinned/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.getMultiListingPinnedSectionReturn;
        this.XHRHdl.execute();
    }

    protected getMultiListingPinnedSectionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.configHomePage.setMultiListingPinnedSection(responseParsed.data);
                obj.loadingPinnedArticlesHome = false;
                obj.getLatestYoutubeVideosSection();
            });
        }
    }

    protected getLatestYoutubeVideosSection() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.loadingPinnedArticlesHome = true;

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/homepage/latestYoutubeVideos/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.getLatestYoutubeVideosSectionReturn;
        this.XHRHdl.execute();
    }

    protected getLatestYoutubeVideosSectionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.configHomePage.setLatestYoutubeVideosSection(responseParsed.data);
                obj.loadingPinnedArticlesHome = false;
                obj.getPinnedTradingCards();
            });
        }
    }

    public validateMultipleHubPages() {
        return this.configHomePage.validatePinnedWidget();
    }


    //image picker functions
    public getUrlBase(): string {
        let idBrand = this.getVnAppZone().app.params.idBrand;

        return idBrand ? "/api/brand/" + idBrand : "/api";
    }


    protected getImageData() {
        if (this.imageXHRHdl) {
            this.imageXHRHdl.cancelAndReset();
        }

        this.configHomePage.imagePicker.showLoading();

        let formReq_url: string = this.getUrlBase() + "/images/get/";
        let formReq_params: Array<Array<string>> = [];


        formReq_params.push([
            "data",
            ko.toJSON(this.configHomePage.imagePicker.getViewModelForRequest()),
        ]);

        this.imageXHRHdl = new XMLHttpRequestHandler(
            formReq_url,
            formReq_params,
            this
        );
        this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
        this.imageXHRHdl.execute();
    }

    protected onGetImageDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateImagePickerForm(responseParsed);
                obj.configHomePage.imagePicker.hideLoading();
                if (
                    obj.configHomePage.imagePicker.getSelectedTab() == "images" ||
                    obj.isSaveImage
                ) {
                    obj.isSaveImage = false;
                }
            });
        };
    }

    protected bytesToSize(bytes) {
        var sizes = ["KB", "MB", "GB", "TB"];
        if (bytes == 0) return "n/a";
        var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
        if (i == 0) return bytes + " " + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    }

    protected updateImagePickerForm(responseParsed) {
        let selectedImages = this.configHomePage.imagePicker.getSelectedImages();

        if (responseParsed.paginatedImages && responseParsed.paginatedImages.data) {
            for (let image of responseParsed.paginatedImages.data) {
                image.selected = false;
                let imageSelected = selectedImages.find((i) => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.configHomePage.imagePicker.setImagesPagination(
                responseParsed.paginatedImages
            );
            this.configHomePage.imagePicker.setImageResults(
                responseParsed.paginatedImages.data
            );
        }

        if (responseParsed.ratios) {
            this.configHomePage.imagePicker.setRatios(responseParsed.ratios);
        }

        if (responseParsed.orientations) {
            this.configHomePage.imagePicker.setOrientations(responseParsed.orientations);
        }

        if (responseParsed.uploadSources) {
            this.configHomePage.imagePicker.setUploadSources(
                responseParsed.uploadSources,
                responseParsed.selectedUploadSource
            );
        }

        if (responseParsed.idBrand) {
            this.configHomePage.imagePicker.setIdBrand(responseParsed.idBrand);
        }

        this.configHomePage.validatePinnedWidget();
    }

    public removeImage(target) {
        this.configHomePage.clearImage(target);
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_home_page.ts